var vars = require('./core');

module.exports = vars.createClass('Line', ['getPointsAtEvent']);



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-chartjs/lib/line.js
 ** module id = 970
 ** module chunks = 2
 **/